var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "ruleForm",
      staticClass: "demo-ruleForm",
      attrs: { model: _vm.ddctQrcodeInfo, rules: _vm.rules }
    },
    [
      _c("div", { staticClass: "simple-form" }, [
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _c("label", { staticClass: "required" }, [_vm._v("商户名称")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-value width-3x" }, [
            _c("span", [_vm._v(_vm._s(_vm.ddctQrcodeInfo.merchantName))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _c("label", { staticClass: "required" }, [_vm._v("用途")])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value width-3x" },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "bizAspect" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      on: { change: _vm.changeUsage },
                      model: {
                        value: _vm.ddctQrcodeInfo.usage,
                        callback: function($$v) {
                          _vm.$set(_vm.ddctQrcodeInfo, "usage", $$v)
                        },
                        expression: "ddctQrcodeInfo.usage"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("入职")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 2 } }, [_vm._v("离职")])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _c("label", { staticClass: "required" }, [_vm._v("机构名称")])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value width-3x" },
            [
              _c("el-input", {
                staticClass: "width-1-5x bottom-line",
                attrs: { disabled: "", type: "text" },
                model: {
                  value: _vm.ddctQrcodeInfo.comName,
                  callback: function($$v) {
                    _vm.$set(_vm.ddctQrcodeInfo, "comName", $$v)
                  },
                  expression: "ddctQrcodeInfo.comName"
                }
              }),
              _vm._v(" "),
              _c("div", {
                staticClass:
                  "form-tips icon iconfont icon-chazhaobiaodanliebiao relation-icon",
                attrs: { title: "选择" },
                on: {
                  click: function($event) {
                    _vm.selectComInfo()
                  }
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _vm.ddctQrcodeInfo.usage == 1
          ? _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", [_vm._v("岗位名称")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value width-3x" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "catName" } },
                    [
                      _c("el-input", {
                        staticClass: "width-1-5x bottom-line",
                        attrs: { disabled: "", type: "text" },
                        model: {
                          value: _vm.ddctQrcodeInfo.roleName,
                          callback: function($$v) {
                            _vm.$set(_vm.ddctQrcodeInfo, "roleName", $$v)
                          },
                          expression: "ddctQrcodeInfo.roleName"
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass:
                          "form-tips icon iconfont icon-chazhaobiaodanliebiao relation-icon",
                        attrs: { title: "选择" },
                        on: {
                          click: function($event) {
                            _vm.selectComRoleInfo()
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _c("label", [_vm._v("码上文字")])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value width-2x" },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "name" } },
                [
                  _c("el-input", {
                    attrs: { type: "text" },
                    model: {
                      value: _vm.ddctQrcodeInfo.topTxt,
                      callback: function($$v) {
                        _vm.$set(_vm.ddctQrcodeInfo, "topTxt", $$v)
                      },
                      expression: "ddctQrcodeInfo.topTxt"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _c("label", [_vm._v("码下文字")])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value width-2x" },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "name" } },
                [
                  _c("el-input", {
                    attrs: { type: "text" },
                    model: {
                      value: _vm.ddctQrcodeInfo.btmTxt,
                      callback: function($$v) {
                        _vm.$set(_vm.ddctQrcodeInfo, "btmTxt", $$v)
                      },
                      expression: "ddctQrcodeInfo.btmTxt"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-16ee83ce", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16ee83ce","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/comn/DdctQrcodeSave.vue
// module id = 4309
// module chunks = 0